var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EntityTable',{attrs:{"entity-type":_vm.entityType,"headers":_vm.state.headers}})}
var staticRenderFns = []

export { render, staticRenderFns }